import script from "./NavItems.vue?vue&type=script&setup=true&lang=js"
export * from "./NavItems.vue?vue&type=script&setup=true&lang=js"

import "./NavItems.vue?vue&type=style&index=0&id=1fbb1669&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbb1669"]])

export default __exports__